"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalTypes_1 = require("../../generated/graphql/globalTypes");
exports.hasExpiredTrial = function (billing) {
    var hasActivePaidPlan = false;
    var hasActiveTrial = false;
    billing.forEach(function (plan) {
        if (plan.plan !== globalTypes_1.Plan.implicit_trial && plan.status === globalTypes_1.PlanStatus.active) {
            hasActivePaidPlan = true;
        }
        else if (plan.plan === globalTypes_1.Plan.implicit_trial && plan.status === globalTypes_1.PlanStatus.active) {
            hasActiveTrial = true;
        }
    });
    return !(hasActivePaidPlan || hasActiveTrial);
};
